export default __webpack_public_path__ + "media/natashaVid.ee2bea64.mp4";